import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { BsTrash } from "react-icons/bs";

import { CandidateExpWrapper } from "./candidateExpPatnerPage.styled";
import { cepListData } from "./constants/mokData";
import MobileNoLayout from "../../components/compLayouts/mobileNoLayout";
import { validate } from "../../constants/validationExp";
import TextInputLayout from "../../components/compLayouts/textInputLayout";
import {
  createCEPAdminReq,
  getCEPsListReq,
} from "../../api/cep/cepAdminRequest";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { SagaActions } from "../../redux/actionTypes";
import { cepAdminType } from "../../types/cepAdminTypes";
import CepListItem from "./components/cepListItem";
import CEPTable from "./components/CEPTable";
import RenderIf from "../../components/renderIf";
import { COUNTRY_CODES } from "../../constants/countryCodes";

type Inputs = {
  nameIs: string;
  firstName: string;
  lastName: string;
  designationIs: string;
  emailIs: string;
  phoneNumberIs: string;
};

export const CandidateExpPatnerPage = () => {
  const Dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const phNo = watch("phoneNumberIs");
  const _numberError = errors.phoneNumberIs?.message;

  const [cepUsers, setcepUsers] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState<string>("+91");
  const [selectedTimeZone, setSelectedTimeZone] = useState<string>("India (GMT+5:30)");
  const [isLoading, setIsLoading] = useState(false);

  const handleCountryCodeChange = (e: any) => {
    const selectedCountryCode = e.countryCode;
    const selectedCountry = COUNTRY_CODES.find(
      (country) => country.countryCode === selectedCountryCode
    );
    if (selectedCountry) {
      setSelectedCountryCode(selectedCountry.countryCode);
      setSelectedTimeZone(selectedCountry.countryTimeZone[0].zone);
    }
  };

  const handleTimeZoneChange = (e: any) => {
    setSelectedTimeZone(e.target.value);
  };

  const createCEPAdminfun = async (data: Inputs) => {
    if (isLoading) return; // Prevent duplicate submissions

    setIsLoading(true);
    try {
      const body = {
        firstName: data?.firstName,
        lastName: data?.lastName,
        email: data?.emailIs,
        PhoneCountryCode: Number(selectedCountryCode.replace("+", "")),
        mobile: data?.phoneNumberIs,
        TimeZone: selectedTimeZone,
        designation: data?.designationIs,
      };
      console.log("createCEPAdminfun body:", body);

      const res = await createCEPAdminReq(body);
      toast.success(res?.message || "CEP Admin created successfully!", {
        autoClose: 4000,
        position: "top-right",
      });
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "prod",
          message: res?.message,
          fileName: "candidateExpPatnerPage",
          methodName: "createCEPAdminfun",
          type: "info",
        },
      });
      reset();
      fetchCEPlistfun();
    } catch (error: any) {
      const errorMessage = error?.errorMsg || "Failed to create CEP Admin. Please try again.";
      toast.error(errorMessage, {
        autoClose: 5000,
        position: "top-right",
      });
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "candidateExpPatnerPage",
          methodName: "createCEPAdminfun",
          type: "error",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCEPlistfun = async () => {
    try {
      const res = await getCEPsListReq();
      setcepUsers(res?.data || []);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "prod",
          message: res?.message,
          fileName: "candidateExpPatnerPage",
          methodName: "fetchCEPlistfun",
          type: "info",
        },
      });
    } catch (error: any) {
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "prod",
          message: error?.errorMsg,
          fileName: "candidateExpPatnerPage",
          methodName: "fetchCEPlistfun",
          type: "error",
        },
      });
    }
  };

  const handleButtonClick = ({ key, data }: { key: string; data?: any }) => {
    const btnFun: any = {
      createCep: (data: Inputs) => createCEPAdminfun(data),
    };
    btnFun[key](data);
  };

  useEffect(() => {
    fetchCEPlistfun();
  }, []);

  return (
    <CandidateExpWrapper className="p-2">
      <div style={{ overflow: "auto" }}>
        <div className="p-1 ">
          <form
            onSubmit={handleSubmit((data) => {
              handleButtonClick({ key: "createCep", data });
            })}
            className="w-100 p-3"
          >
            <p className="my-1 mx-1 lg-text">
              <strong>Add A New Candidate Experience Partner (CEP):</strong>
            </p>
            <div className="m-4"></div>
            <div className="py-3 p-2 m-1 row bg-white rounded shadow-block">
              <div className=" col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.firstName?.message}
                  label={"First Name"}
                  required
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("firstName", {
                      required: " Please enter firstName",
                    })}
                  />
                </TextInputLayout>
              </div>
              <div className=" col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.lastName?.message}
                  label={"Last Name"}
                  required
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("lastName")}
                  />
                </TextInputLayout>
              </div>
              <div className=" col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.designationIs?.message}
                  label={"Designation"}
                  required
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("designationIs", {
                      required: " Please enter designation",
                    })}
                  />
                </TextInputLayout>
              </div>

              {/* <div className=" col-lg-3 col-md-6"></div> */}
              <div className=" col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.emailIs?.message}
                  label={"Email"}
                  required
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("emailIs", {
                      required: " Please enter Email",
                      pattern: {
                        value: validate.email,
                        message: "Entered incorrect email format",
                      },
                    })}
                  />
                </TextInputLayout>
              </div>

              <div className=" col-lg-5 col-md-6">
                <MobileNoLayout
                  isError={_numberError}
                  mobileNumber={phNo}
                  required
                  mobileIcon={false}
                  onCountryCodeChange={handleCountryCodeChange}
                  // countryCodeOptions={COUNTRY_CODES}
                  selectedCountryCode={selectedCountryCode}
                >
                  <input
                    className={`flex-grow-1 `}
                    placeholder=""
                    type="tel"
                    maxLength={10}
                    {...register("phoneNumberIs", {
                      required: "Enter 10 digit mobile number",
                      maxLength: {
                        value: 10,
                        message: "Enter 10 digit mobile number",
                      },
                      minLength: {
                        value: 10,
                        message: "Enter 10 digit mobile number",
                      },
                      pattern: {
                        value: validate.phone,
                        message: "Incorrect mobile number",
                      },
                    })}
                  />
                </MobileNoLayout>
              </div>

              <div className="col-lg-4 col-md-6">
                <TextInputLayout
                  // isError={errors.CEPPartnerIs?.message}
                  label={"Time Zone"}
                  required
                >
                  <select
                    className="w-100  border-0 px-2"
                    style={{ outline: "none" }}
                    value={selectedTimeZone}
                    onChange={handleTimeZoneChange}
                  >
                    {selectedCountryCode &&
                      COUNTRY_CODES.find(
                        (country) => country.countryCode === selectedCountryCode
                      )?.countryTimeZone.map((timezone) => (
                        <option key={timezone.zone} value={timezone.zone}>
                          {timezone.zone}
                        </option>
                      ))}
                  </select>
                </TextInputLayout>
              </div>

              {/* <div className=" col-lg-3 col-md-6">
                <TextInputLayout
                  isError={errors.emailIs?.message}
                  label={"Email"}
                  required
                >
                  <input
                    className={`flex-grow-1`}
                    autoComplete="off"
                    {...register("emailIs", {
                      required: " Please enter Email",
                      pattern: {
                        value: validate.email,
                        message: "Entered incorrect email format",
                      },
                    })}
                  />
                </TextInputLayout>
              </div> */}
              <div className=" col-lg-3 col-md-4 d-flex flex-column justify-content-end p-2">
                <button
                  type="submit"
                  className="btn primary-bg text-white w-100"
                  disabled={isLoading}
                  style={{ opacity: isLoading ? 0.6 : 1 }}
                >
                  {isLoading ? "Creating..." : "Create CEP"}
                </button>
              </div>
            </div>
          </form>
        </div>

        {/* <div className="border w-100"></div> */}
        <div className="d-flex p-2">
          <div className="w-100 px-3">
            <div className="bg-white py-3 p-1 rounded shadow-block">
              <RenderIf isShow={cepUsers?.length > 0}>
                <CEPTable dataIs={cepUsers} onDeleteRow={fetchCEPlistfun} />
              </RenderIf>
              <RenderIf isShow={cepUsers?.length < 1}>
                <p className="px-2 m-1 lg-text">
                  <>Edit a CEP</>
                </p>
                <div className="w-100 d-flex align-items-center justify-content-center">
                  <p className="text-secondary m-3">-: No Data :-</p>
                </div>
              </RenderIf>
            </div>
          </div>
        </div>
      </div>
    </CandidateExpWrapper>
  );
};

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  input {
    border: none;
    outline: none;
    padding: 0px 10px;
  }
  .input_box {
    display: flex;
    align-items: center;
    border-radius: 8px;
    /* height: 35px; */
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid rgb(216, 216, 216);
  }
  .icon_box {
    height: 25px;
    width: 25px;
    border: 0px solid;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  .image_icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border: 0px solid;
  }
  .country_code_box {
    /* width: 100px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 8px;
    height: 45px;
    border: 1px solid rgb(200, 200, 200);
  }
`;
